import { render, staticRenderFns } from "./ShopRegistrationForm.vue?vue&type=template&id=5a575218&"
import script from "./ShopRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ShopRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports